enum BookingRoleWorkerShiftStatus {
	Shortlisted = 5,
	Offered = 10,
	Retracted = 20,
	DeclinedOffer = 30,
	Applied = 40,
	Rejected = 50,
	Reserve = 60,
	BookedUnconfirmed = 70,
	DeclinedBooking = 80,
	BookedConfirmed = 90,
	Cancelled = 100,
}

export default BookingRoleWorkerShiftStatus;